import { Routes } from '@angular/router';
import { AppUrls } from './routing/app-urls';

export const routes: Routes = [
  {
    path: AppUrls.Client,
    loadChildren: () =>
      import('./client/client-routes').then((m) => m.ClientRoutes),
  },
  {
    path: '**',
    redirectTo: AppUrls.Root,
  },
];
